/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { IconWrap as n, classNames as o } from "@progress/kendo-react-common";
import * as t from "react";
const c = t.forwardRef(
  (a, e) => /* @__PURE__ */ t.createElement(n, { ref: e, ...a, className: o("k-input-validation-icon", a.className) })
);
c.displayName = "KendoReactInputValidationIcon";
export {
  c as InputValidationIcon
};
